export const CASES_FORM_FIELDS = [
    {
        label: 'Cases Information',
        fields: [
            {
                settingFieldName: 'sequenceNumber',
                formFieldname: 'sequenceNumber'
            },
            {
                settingFieldName: 'caseAssociationName',
                formFieldname: 'caseAssociationName'
            },
            {
                settingFieldName: 'associationName',
                formFieldname: 'associationName'
            },
            {
                settingFieldName: 'contactName',
                formFieldname: 'contactName'
            },
            {
                settingFieldName: 'contactEmailAddress',
                formFieldname: 'contactEmailAddress'
            },
            {
                settingFieldName: 'contactMobileNo',
                formFieldname: 'contactMobileNo'
            },
            {
                settingFieldName: 'sourceName',
                formFieldname: 'sourceName'
            },
            {
                settingFieldName: 'categoryName',
                formFieldname: 'categoryName'
            },
            {
                settingFieldName: 'subCategoryName',
                formFieldname: 'subCategoryName'
            },
            {
                settingFieldName: 'priorityName',
                formFieldname: 'priorityName'
            },
            {
                settingFieldName: 'subject',
                formFieldname: 'subject'
            },
            {
                settingFieldName: 'reportedBy',
                formFieldname: 'reportedBy'
            },
            {
                settingFieldName: 'attachmentLinks',
                formFieldname: 'attachmentLinks'
            },
            {
                settingFieldName: 'ticketDesc',
                formFieldname: 'ticketDesc'
            },
            {
                settingFieldName: 'stageName',
                formFieldname: 'stageName'
            },
            {
                settingFieldName: 'resolutionDate',
                formFieldname: 'resolutionDate'
            },
            {
                settingFieldName: 'resolutionComment',
                formFieldname: 'resolutionComment'
            },
            {
                settingFieldName: 'assignedGroup',
                formFieldname: 'assignedGroup'
            },
            {
                settingFieldName: 'assignedUser',
                formFieldname: 'assignedUser'
            },
            {
                settingFieldName: 'createdByName',
                formFieldname: 'createdByName'
            },
            {
                settingFieldName: 'createdDate',
                formFieldname: 'createdDate'
            },   
            {
                settingFieldName: 'lastUpdatedByName',
                formFieldname: 'lastUpdatedByName'
            },
            {
                settingFieldName: 'updatedDate',
                formFieldname: 'updatedDate'
            }
        ]
    },
    // {
    //     label: 'Selected Products',
    //     fields: [
    //         {
    //             settingFieldName: 'productName',
    //             formFieldname: 'itemNo'
    //         },
    //         {
    //             settingFieldName: 'productDescription',
    //             formFieldname: 'productDescription'
    //         },
    //         {
    //             settingFieldName: 'uom',
    //             formFieldname: 'uom'
    //         },
    //         {
    //             settingFieldName: 'unit',
    //             formFieldname: 'unit'
    //         },
    //         {
    //             settingFieldName: 'unit',
    //             formFieldname: 'qty'
    //         },
    //         {
    //             settingFieldName: 'price',
    //             formFieldname: 'price'
    //         },
    //         {
    //             settingFieldName: 'caseDetails',
    //             formFieldname: 'itemTotal'
    //         }
    //     ]
    // }
]
